// @flow

import React, { useEffect, useState } from 'react';

import { RouterSelectors, useRedux } from '@zapier/toolbox-redux-framework';
import {
  GlobalStylesProvider,
  PLATFORM_COOKIE,
  useTheme,
} from '@zapier/design-system';
import { Header as PlatformHeader } from '@zapier/product-dev-platform';
import { readCookie } from '@zapier/cookies';

import { Profile } from '@zapier/shared-entities';

import type { HeaderUser } from '@zapier/product-dev-platform';

const mapStateToProps = state => {
  const isLoggedIn = Profile.selectors.all.isLoggedIn(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const user: ?HeaderUser = isLoggedIn
    ? {
        name: Profile.selectors.normalizedName(currentProfile) || '',
        avatarUrl: Profile.selectors.gravatarUrl(currentProfile),
      }
    : null;

  return {
    currentUrl: RouterSelectors.currentUrl(state) || '',
    user,
  };
};

function Header() {
  const { isPlatform } = useTheme();
  const { currentUrl, user } = useRedux(mapStateToProps);
  return (
    <PlatformHeader
      currentUrl={currentUrl}
      isRebranded={isPlatform}
      user={user}
    />
  );
}

function PlatformHeaderProvider() {
  const [isPlatform, setIsPlatform] = useState(false);
  useEffect(() => {
    const hasPlatformCookie = readCookie(PLATFORM_COOKIE) === 'true';
    setIsPlatform(hasPlatformCookie);
  }, []);

  return (
    <GlobalStylesProvider isPlatform={isPlatform} isRebrand={true}>
      <Header />
    </GlobalStylesProvider>
  );
}

export default PlatformHeaderProvider;
